/**
 * Application configuration
 *
 * Centralized configuration for the web application.
 * All environment-specific values should be accessed through this module.
 */

/**
 * API configuration
 */
export const apiConfig = {
  /**
   * Base URL for the API, normalized to remove trailing slashes.
   * Uses VITE_BASE_API_URL environment variable or defaults to api.webiotpro.com.
   */
  baseUrl: (import.meta.env.VITE_BASE_API_URL || 'https://api.webiotpro.com').replace(/\/$/, ''),
} as const;

/**
 * Build the full URL for an API endpoint
 * @param path - The API path (should start with /)
 * @returns Full URL including base URL
 */
export function buildApiUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${apiConfig.baseUrl}${normalizedPath}`;
}
